import type ModalConversationInterceptorService from '../commons/services/modal-conversation-interceptor.service';

export class DocumentInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService) {
    }

    public register() {
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ExemplarsHaveNotDeletableStatusException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('LoanRequestDocumentWasLoanedInPastException');
    }

}
